module.exports = __webpack_public_path__ + "static/media/allergy_slider_phone1.240072bc.png";